<template>
    <DModal
        v-model="freeMonthsForm.activity_log_comment"
        :title="__('customers.contracts.no_of_months')"
        is-confirm
        :show="showModal || modalHasErrors"
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        :show-incident-list="true"
        :customer-id="contract?.customer_id ?? 0"
        @setIncident="setIncident"
        @confirm="updateFreeMonths()"
        @close="$emit('close-modal')"
        @clearFields="resetFreeMonthsForm()"
    >
        <div style="padding: 20px;">
            <DRow style="margin-top: 16px;">
                <DCol>
                    <DInput
                        id="free_months"
                        v-model="freeMonthsForm.free_months"
                        :label="__('customers.contracts.no_of_months')"
                        add-label-classes="required"
                        type="text"
                    />
                    <p
                        v-if="errors.free_months"
                        class="help-block text-danger"
                    >
                        {{ errors.free_months }}
                    </p>
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>

export default {
    name: 'FreeMonthsModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            freeMonthsForm: this.$inertia.form({
                free_months: this.contract.free_months,
                activity_log_comment: '',
                incident_id: null
            }),
            errors: this.errorsData,
            modalHasErrors: false
        }
    },
    methods: {
        updateFreeMonths () {
            this.freeMonthsForm.post(this.$route('customers.customers.contracts.free-months', {
                customer: this.contract.customer_id,
                contract: this.contract.id
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                    this.resetFreeMonthsForm()
                    this.modalHasErrors = false
                },
                onError: (error) => {
                    this.errors = error
                    this.modalHasErrors = true
                }
            })
        },
        resetFreeMonthsForm () {
            this.freeMonthsForm.free_months = this.contract.free_months
            this.errors = {}
        },
        setIncident (value) {
            this.freeMonthsForm.incident_id = value
        }
    }
}
</script>
